import Popups from './popups.js';
import { onReady, on, postData } from './utils.js';

onReady( function() {
	on( 'body', 'submit', '#login-form', function( event ) {
		const form = event.target;
		const login_error_el = document.getElementById( 'login-form-error' );

		login_error_el.hidden = true;

		event.preventDefault();

		postData( form.action, new FormData( form ) ).then( ( response ) => {
			if ( response.status !== 200 ) {
				response.text().then( ( message ) => {
					login_error_el.firstElementChild.innerHTML = message;
					login_error_el.hidden = false;
				} );
			} else {
				document.location.reload( true );
			}
		} );
	} );

	on( 'body', 'submit', '#lost-password-form', function( event ) {
		const form = event.target;
		const login_error_el = document.getElementById( 'lost-password-form-error' );

		login_error_el.hidden = true;

		event.preventDefault();

		postData( form.action, new FormData( form ) ).then( ( response ) => {
			if ( response.status !== 200 ) {
				response.text().then( ( message ) => {
					login_error_el.firstElementChild.innerHTML = message;
					login_error_el.hidden = false;
				} );
			} else {
				Popups.hide();
				Popups.show( {
					isClosable: true,
					type: 'inline',
					src: '#popup-profile-forgotten-password-success',
					size: 'medium',
				} );
			}
		} );
	} );
} );
